export const LOAD_PERMISSIONS = 'LOAD_PERMISSIONS';
export const FETCH_PERMISSIONS = 'FETCH_PERMISSIONS';
export const RECEIVED_PERMISSIONS = 'RECEIVED_PERMISSIONS';
export const ERROR_FETCH_PERMISSIONS = 'ERROR_FETCH_PERMISSIONS';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
